(function () {
  var STORAGE_KEY = 'tempsprite_rfq_items_v1';
  var RFQ_PATH = '/pages/contact-us-for-wholesale-request';

  function readItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function clean(value) {
    return String(value || '').trim();
  }

  function getParam(name) {
    return clean(new URLSearchParams(window.location.search).get(name));
  }

  function absoluteUrl(url) {
    if (!url) return '';
    if (url.indexOf('http') === 0) return url;
    return window.location.origin + url;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function addItem(item) {
    var items = readItems();
    var key = item.sku || item.handle || item.url || item.title;
    var exists = items.some(function (current) {
      return current.key === key;
    });

    if (!exists) {
      items.push({
        key: key,
        title: clean(item.title) || 'Product inquiry',
        sku: clean(item.sku),
        handle: clean(item.handle),
        url: absoluteUrl(clean(item.url)),
        image: clean(item.image),
        qty: clean(item.qty) || '1',
        note: ''
      });
      saveItems(items);
      return true;
    }

    return false;
  }

  function itemExists(item) {
    var key = item.sku || item.handle || item.url || item.title;
    return readItems().some(function (current) {
      return current.key === key;
    });
  }

  function addItemFromUrl() {
    var title = getParam('title');
    var sku = getParam('sku');
    var url = getParam('url');
    var handle = getParam('handle');
    var image = getParam('image');
    if (!title && !sku && !url && !handle) return;

    addItem({
      title: title,
      sku: sku,
      url: url,
      handle: handle,
      image: image,
      qty: getParam('qty')
    });

    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

  function handleProductButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ts-rfq-add]');
      if (!button) return;

      event.preventDefault();
      var item = {
        title: button.getAttribute('data-title'),
        sku: button.getAttribute('data-sku'),
        url: button.getAttribute('data-url'),
        handle: button.getAttribute('data-handle'),
        image: button.getAttribute('data-image'),
        qty: '1'
      };

      addItem(item);

      button.textContent = 'Added to Inquiry List';
      button.classList.add('ts-rfq-added');
    });
  }

  function addCardActionStyles() {
    if (document.getElementById('ts-rfq-card-styles')) return;

    var style = document.createElement('style');
    style.id = 'ts-rfq-card-styles';
    style.textContent = [
      '.cfp-prod-wrapper{display:none!important}',
      'form[action*="/cart/add"],[data-quick-buy],[data-quickshop-full],[data-quickshop-slim],.productitem--actions,a[href="/cart"]{display:none!important}',
      '.price,.product-price,.productitem--price,.productitem__price,.productitem--listview-price,.product__price,[data-product-price],[data-price-current],[data-price-compare],.price__current,.price__compare-at{display:none!important}',
      '.productitem--title{min-height:2.7em;max-height:2.7em;overflow:hidden;margin-bottom:0!important;line-height:1.35!important}',
      '.productitem--title>a{display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-clamp:2}',
      '.ts-rfq-card-actions{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:8px;margin-top:14px}',
      '.ts-rfq-card-actions__button{min-height:42px;display:flex;align-items:center;justify-content:center;box-sizing:border-box;padding:8px 10px;border:1px solid #ef412f;background:#fff;color:#ef412f;font:inherit;font-size:14px;font-weight:700;line-height:1.25;text-align:center;text-decoration:none;cursor:pointer}',
      '.ts-rfq-card-actions__button--details{border-color:#ef412f;background:#ef412f;color:#fff}',
      '.ts-rfq-card-actions__button--add{border-color:#ef412f;background:#fff;color:#ef412f}',
      '.ts-rfq-card-actions__button--add.ts-rfq-added{border-color:#ef412f;background:#fff;color:#ef412f}',
      '.ts-rfq-card-actions__button:hover,.ts-rfq-card-actions__button:focus-visible{filter:brightness(.94);outline:2px solid #ef412f;outline-offset:2px}',
      '.ts-rfq-product-cta{margin:18px 0 22px;padding:18px;border:1px solid #d9e2ec;background:#f7fafc}',
      '.ts-rfq-product-cta__title{margin:0 0 12px;font-weight:700}.ts-rfq-product-cta__copy{margin:0 0 14px;line-height:1.5}',
      '.ts-rfq-product-cta__actions{display:flex;flex-wrap:wrap;gap:10px}',
      '.ts-rfq-product-cta__button{min-height:46px;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;padding:12px 18px;border:1px solid #ef412f;background:#fff;color:#ef412f;font:inherit;font-weight:700;line-height:1.25;text-decoration:none;cursor:pointer}',
      '.ts-rfq-product-cta__button--add{border-color:#ef412f;background:#ef412f;color:#fff}',
      '.ts-rfq-product-cta__button--add.ts-rfq-added{border-color:#ef412f;background:#fff;color:#ef412f}',
      '.ts-rfq-product-cta__button:hover,.ts-rfq-product-cta__button:focus-visible{filter:brightness(.94);outline:2px solid #ef412f;outline-offset:2px}',
      '@media(max-width:480px){.ts-rfq-card-actions{grid-template-columns:1fr}.ts-rfq-card-actions__button{font-size:13px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function productDataFromCard(card) {
    var titleLink = card.querySelector('.productitem--title a[data-product-page-link]');
    var image = card.querySelector('.productitem--image-primary');
    var pluginTitle = card.querySelector('.cfp-prod-title');
    var pluginHandle = card.querySelector('.cfp-prod-handle');
    var url = card.getAttribute('data-product-quickshop-url') || (titleLink && titleLink.getAttribute('href')) || '';
    var handle = pluginHandle ? pluginHandle.textContent : '';

    return {
      title: pluginTitle ? pluginTitle.textContent : (titleLink ? titleLink.textContent : ''),
      sku: '',
      handle: clean(handle),
      url: url,
      image: image ? (image.currentSrc || image.getAttribute('src') || '') : ''
    };
  }

  function updateCardActionState(button, item) {
    if (!button) return;
    if (itemExists(item)) {
      button.textContent = 'Added';
      button.classList.add('ts-rfq-added');
    } else {
      button.textContent = '+ Add to List';
      button.classList.remove('ts-rfq-added');
    }
  }

  function decorateProductCards() {
    addCardActionStyles();

    document.querySelectorAll('[data-product-item]').forEach(function (card) {
      var pluginWrapper = card.querySelector('.cfp-prod-wrapper');
      if (pluginWrapper) pluginWrapper.style.setProperty('display', 'none', 'important');
      if (card.querySelector('.ts-rfq-card-actions')) return;

      var info = card.querySelector('.productitem--info');
      var item = productDataFromCard(card);
      if (!info || !item.title || !item.url) return;

      var actions = document.createElement('div');
      actions.className = 'ts-rfq-card-actions';
      actions.innerHTML = [
        '<a class="ts-rfq-card-actions__button ts-rfq-card-actions__button--details" href="' + escapeHtml(item.url) + '">View Details</a>',
        '<button class="ts-rfq-card-actions__button ts-rfq-card-actions__button--add" type="button" title="Add to Inquiry List">+ Add to List</button>'
      ].join('');

      var addButton = actions.querySelector('button');
      updateCardActionState(addButton, item);
      addButton.addEventListener('click', function () {
        addItem(item);
        updateCardActionState(addButton, item);
      });
      info.appendChild(actions);
    });
  }

  function watchProductCards() {
    decorateProductCards();
    if (!document.body || document.body.getAttribute('data-ts-rfq-card-watch')) return;

    document.body.setAttribute('data-ts-rfq-card-watch', 'true');
    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        decorateProductCards();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function blockNativeCartSubmissions() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      event.preventDefault();
    });
  }

  function renderRfqPage() {
    if (!/\/pages\/contact-us-for-wholesale-request$/.test(window.location.pathname.replace(/\/+$/, ''))) return;
    addItemFromUrl();

    document.body.classList.add('ts-rfq-page-active');

    var main = document.querySelector('#site-main') || document.querySelector('main') || document.body;
    var wrapper = document.createElement('section');
    wrapper.id = 'tempsprite-rfq';
    wrapper.className = 'ts-rfq';
    wrapper.innerHTML = [
      '<style>',
      '.ts-rfq{max-width:1440px;margin:0 auto;padding:28px 24px 48px;color:#1f2933;font-family:inherit}',
      '.ts-rfq__hero{border:1px solid #d9e2ec;background:#f7fafc;padding:24px;margin-bottom:22px}',
      '.ts-rfq h1{margin:0 0 10px;font-size:32px;line-height:1.2}',
      '.ts-rfq h2{margin:28px 0 12px;font-size:22px;line-height:1.3}',
      '.ts-rfq__panel h2{margin:0 0 14px}',
      '.ts-rfq p{line-height:1.6;margin:0 0 12px}',
      '.ts-rfq__grid{display:grid;grid-template-columns:minmax(0,.82fr) minmax(400px,1.18fr);gap:14px;align-items:stretch}',
      '.ts-rfq__panel{box-sizing:border-box;height:100%;border:1px solid #d9e2ec;background:#fff;padding:20px}',
      '.ts-rfq__panel--list{padding:14px;background:#fafafa}.ts-rfq__panel--form{border-color:#cbd5e1}',
      '.ts-rfq__item{border-bottom:1px solid #e5eaf0;padding:9px 0;display:grid;grid-template-columns:44px minmax(0,1fr) auto;gap:10px;align-items:center}',
      '.ts-rfq__item:first-child{padding-top:0}.ts-rfq__item:last-child{border-bottom:0;padding-bottom:0}',
      '.ts-rfq__thumb{width:44px;height:44px;border:1px solid #e5eaf0;object-fit:contain;background:#fff}',
      '.ts-rfq__item-title{display:block;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#1f2933;font-weight:700;text-decoration:none}',
      '.ts-rfq__item-title:hover,.ts-rfq__item-title:focus-visible{text-decoration:underline}',
      '.ts-rfq button.ts-rfq__remove{min-height:30px;border:1px solid #ef412f;background:#fff;color:#ef412f;padding:6px 10px;font:inherit;font-size:12px;font-weight:700;line-height:1;cursor:pointer}',
      '.ts-rfq button.ts-rfq__remove:hover,.ts-rfq button.ts-rfq__remove:focus-visible{background:#ef412f;color:#fff}',
      '.ts-rfq label{display:block;font-weight:700;margin:12px 0 6px}',
      '.ts-rfq__optional{font-weight:400;color:#52616b}',
      '.ts-rfq input,.ts-rfq textarea{width:100%;box-sizing:border-box;border:1px solid #cbd5e1;padding:10px 12px;font:inherit;background:#fff}',
      '.ts-rfq textarea{min-height:158px;resize:vertical}',
      '.ts-rfq__row{display:grid;grid-template-columns:1fr 1fr;gap:12px}',
      '.ts-rfq__row label{white-space:nowrap;font-size:14px}',
      '.ts-rfq__actions{display:flex;flex-wrap:wrap;gap:10px;margin-top:16px}',
      '.ts-rfq button,.ts-rfq__button{display:inline-flex;align-items:center;justify-content:center;border:0;background:#ef412f;color:#fff;padding:11px 16px;font-weight:700;text-decoration:none;cursor:pointer}',
      '.ts-rfq__button--secondary,.ts-rfq__button--ghost{border:1px solid #ef412f;background:#fff;color:#ef412f}',
      '.ts-rfq__button--secondary:hover,.ts-rfq__button--secondary:focus-visible,.ts-rfq__button--ghost:hover,.ts-rfq__button--ghost:focus-visible{background:#ef412f;color:#fff}',
      '.ts-rfq__empty{background:#fff7ed;border:1px solid #fed7aa;padding:14px;color:#7c2d12}',
      '.ts-rfq__notice{font-size:14px;color:#52616b;margin-top:10px}',
      '.ts-rfq__submit-status{margin-top:12px;padding:10px 12px;border:1px solid #cbd5e1;background:#f7fafc;color:#1f2933;font-size:14px}',
      '.ts-rfq__success{grid-column:1/-1;border:1px solid #86b69b;background:#f2faf5;padding:28px}',
      '.ts-rfq__success h2{margin:0 0 10px;color:#174c2d;font-size:26px}',
      '.ts-rfq__success p{max-width:760px;margin:0 0 12px}',
      '.ts-rfq button[disabled]{cursor:wait;opacity:.7}',
      '.ts-rfq-page-active #site-main>section:not(#tempsprite-rfq),.ts-rfq-page-active #site-main>.shopify-section{display:none!important}',
      '@media(max-width:820px){.ts-rfq{max-width:none;padding:20px 14px 36px}.ts-rfq h1{font-size:26px}.ts-rfq__grid,.ts-rfq__row{grid-template-columns:1fr}.ts-rfq__item{grid-template-columns:44px minmax(0,1fr) auto}.ts-rfq__thumb{width:44px;height:44px}}',
      '</style>',
      '<div class="ts-rfq__hero">',
      '<h1>Request a Quote</h1>',
      '<p>Send your contact details with the products you are interested in. We will follow up by email to confirm requirements, options, and pricing.</p>',
      '<p class="ts-rfq__notice">Your product list gives our team a clear starting point for the conversation.</p>',
      '</div>',
      '<div class="ts-rfq__grid">',
      '<div class="ts-rfq__panel ts-rfq__panel--list"><h2>Your Inquiry List</h2><div id="ts-rfq-list"></div><div class="ts-rfq__actions"><a class="ts-rfq__button ts-rfq__button--secondary" href="/collections/all">Continue Browsing</a><button type="button" class="ts-rfq__button--ghost" id="ts-rfq-clear">Clear List</button></div></div>',
      '<div class="ts-rfq__panel ts-rfq__panel--form"><h2>Contact Details</h2><form id="ts-rfq-form" method="post" action="/contact#contact_form"><input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓"><label for="ts-name">Name</label><input id="ts-name" name="contact[name]" autocomplete="name" required><label for="ts-email">Work Email</label><input id="ts-email" name="contact[email]" type="email" autocomplete="email" required><div class="ts-rfq__row"><div><label for="ts-company">Company <span class="ts-rfq__optional">(optional)</span></label><input id="ts-company" name="contact[company]"></div><div><label for="ts-phone">Phone / WhatsApp <span class="ts-rfq__optional">(optional)</span></label><input id="ts-phone" name="contact[phone]" autocomplete="tel"></div></div><label for="ts-message">Message <span class="ts-rfq__optional">(optional)</span></label><textarea id="ts-message" placeholder="Anything you would like us to know before we contact you?"></textarea><textarea id="ts-body" name="contact[body]" hidden></textarea><div class="ts-rfq__actions"><button type="submit" id="ts-rfq-submit">Send Inquiry</button></div><div class="ts-rfq__submit-status" id="ts-rfq-submit-status" role="status" aria-live="polite" hidden></div><p class="ts-rfq__notice">We will use your details only to respond to this inquiry.</p></form></div>',
      '</div>'
    ].join('');

    main.insertBefore(wrapper, main.firstChild);
    var loadingShell = document.getElementById('tempsprite-rfq-loading');
    if (loadingShell) loadingShell.remove();

    var listEl = document.getElementById('ts-rfq-list');
    var clearBtn = document.getElementById('ts-rfq-clear');
    var form = document.getElementById('ts-rfq-form');
    var bodyField = document.getElementById('ts-body');
    var messageField = document.getElementById('ts-message');
    var submitButton = document.getElementById('ts-rfq-submit');
    var submitStatus = document.getElementById('ts-rfq-submit-status');

    function renderSubmissionSuccess() {
      saveItems([]);
      var grid = wrapper.querySelector('.ts-rfq__grid');
      grid.innerHTML = [
        '<section class="ts-rfq__success" role="status" aria-live="polite" tabindex="-1">',
        '<h2>Inquiry sent successfully</h2>',
        '<p>Thank you. We have received your inquiry and will contact you at the work email provided to confirm product requirements, options, and pricing.</p>',
        '<p>Please allow up to one business day for our initial reply.</p>',
        '<div class="ts-rfq__actions"><a class="ts-rfq__button" href="/collections/all">Continue Browsing</a></div>',
        '</section>'
      ].join('');
      var success = grid.querySelector('.ts-rfq__success');
      if (success) success.focus();
    }

    if (getParam('contact_posted') === 'true') {
      renderSubmissionSuccess();
      return;
    }

    function renderList() {
      var items = readItems();
      if (!items.length) {
        listEl.innerHTML = '<div class="ts-rfq__empty">No products have been added yet. You can still submit a general sourcing request, or continue browsing products.</div>';
        return;
      }

      listEl.innerHTML = items.map(function (item, index) {
        return [
          '<div class="ts-rfq__item" data-index="' + index + '">',
          item.image ? '<img class="ts-rfq__thumb" src="' + escapeHtml(item.image) + '" alt="">' : '<div class="ts-rfq__thumb"></div>',
          item.url ? '<a class="ts-rfq__item-title" href="' + escapeHtml(item.url) + '" target="_blank" rel="noopener">' + escapeHtml(item.title) + '</a>' : '<div class="ts-rfq__item-title">' + escapeHtml(item.title) + '</div>',
          '<button type="button" class="ts-rfq__remove" data-remove="' + index + '">Remove</button>',
          '</div>'
        ].join('');
      }).join('');
    }

    function buildBody() {
      var items = readItems();
      var lines = [];
      lines.push('TempSprite website inquiry');
      lines.push('');
      lines.push('Customer message:');
      lines.push(clean(messageField.value) || '(No additional message)');
      lines.push('');
      lines.push('Inquiry products:');
      if (!items.length) {
        lines.push('(No product selected. General sourcing request.)');
      } else {
        items.forEach(function (item, index) {
          lines.push('');
          lines.push((index + 1) + '. ' + clean(item.title));
          if (item.sku) lines.push('SKU: ' + clean(item.sku));
          if (item.url) lines.push('Product URL: ' + clean(item.url));
        });
      }
      bodyField.value = lines.join('\n');
    }

    listEl.addEventListener('click', function (event) {
      var removeIndex = event.target.getAttribute('data-remove');
      if (removeIndex === null) return;
      var items = readItems();
      items.splice(Number(removeIndex), 1);
      saveItems(items);
      renderList();
    });

    clearBtn.addEventListener('click', function () {
      saveItems([]);
      renderList();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      buildBody();
      submitButton.disabled = true;
      submitButton.textContent = 'Sending...';
      submitStatus.hidden = false;
      submitStatus.textContent = 'Sending your inquiry. Please wait and keep this page open.';
      form.setAttribute('aria-busy', 'true');

      window.fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'follow'
      }).then(function (response) {
        if (!response.ok || !/contact_posted=true/.test(response.url)) {
          throw new Error('Shopify did not confirm the inquiry submission.');
        }
        renderSubmissionSuccess();
      }).catch(function () {
        submitButton.disabled = false;
        submitButton.textContent = 'Send Inquiry';
        submitStatus.textContent = 'We could not confirm your inquiry. Please try again, or email hk@focuswellgroup.com.';
        form.removeAttribute('aria-busy');
      });
    });
    renderList();
  }

  handleProductButtons();
  blockNativeCartSubmissions();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchProductCards();
      renderRfqPage();
    });
  } else {
    watchProductCards();
    renderRfqPage();
  }
})();
